import { P as Panel } from './LineSpacingPanel-f2d89955.js';
import 'react';
import 'prop-types';
import 'wix-rich-content-common';
import 'classnames';

const Modals = {
  LINE_SPACING: "LINE_SPACING"
};
const ModalsMap = {
  [Modals.LINE_SPACING]: Panel
};

export { Modals, ModalsMap };
//# sourceMappingURL=modals.js.map
